import { useEffect, useRef, useState } from 'react';

const useInfiniteScroll = ({ loadMore, hasMore, isLoading }) => {
  const observer = useRef(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (isLoading) return;
    if (!hasMore) return;

    const handleObserver = (entries) => {
      const target = entries[0];
      if (target.isIntersecting) {
        setIsFetching(true);
        loadMore().finally(() => setIsFetching(false));
      }
    };

    observer.current = new IntersectionObserver(handleObserver);
  }, [isLoading, hasMore, loadMore]);

  const loaderRef = useRef(null);

  useEffect(() => {
    if (observer.current && loaderRef.current) {
      observer.current.observe(loaderRef.current);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
      if (observer.current && loaderRef.current) {
        observer.current.unobserve(loaderRef.current);
      }
    };
  }, [loaderRef.current]);

  return { loaderRef, isFetching };
};

export default useInfiniteScroll;
